<template>
  <div class="footer">
    <p>登录后即代表您同意并愿意遵守<a href="/agreement/user_agreement.html">《用户协议》</a> 和 <a href="/agreement/privacy_policy.html">《隐私协议》</a></p>
  </div>
</template>

<script>
export default {
  data(){
    return{}
  }
};
</script>

<style scoped>
.footer {
  margin: auto auto 24px;
  width: 100%;
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  height: 22px;
  line-height: 22px;
  color: #b6b6b6;
}
.footer > p > a {
  color: #74b3fa;
}
</style>